export const TOTAL_PAGES = 7
export const RECOMMENDED_CARS_URL = '/recommended-cars'
export const LIFESTYLE_URL = '/lifestyle'
export const LIFESTYLE_STEP_NAMES = ['budget', 'passengers', 'roads', 'distance', 'frequency', 'importance', 'textual']

export const CHILD_AGE_GROUPS = ['Age 0 to 4', 'Age 5 to 9', 'Age 10 to 14', 'Age 15 to 17']

export const ADULT_AGE_GROUPS = [
  'Age 18 to 24',
  'Age 25 to 29',
  'Age 30 to 34',
  'Age 35 to 39',
  'Age 40 to 44',
  'Age 45 to 49',
  'Age 50 to 54',
  'Age 55 to 59',
  'Age 60 to 64',
  'Age 65 to 69',
  'Age 70 to 74',
  'Age 75 to 79',
  'Age 80 to 84',
  'Age 85 and over',
]

export const HEIGHT_GROUPS = ['Short', 'Average', 'Tall']

export const PASSENGER_TYPE: Array<'Adult' | 'Child' | 'Dog'> = ['Adult', 'Child', 'Dog']

export const DOG_SIZES = ['Small', 'Average', 'Large']

export const FREQUENCY_OPTIONS = ['Never', 'Rarely', 'Sometimes', 'Very Often', 'Always']

export const FREQUENCY_DRIVE_OPTIONS = ['Every day', 'A few times a week', 'Weekend driver', 'Occasional jollies']

export const TEXTUAL_OPTIONS = [
  { id: 'fuel-economy', label: 'Fuel economy' },
  { id: 'environment', label: 'Environment' },
  { id: 'speed', label: 'Speed' },
  { id: 'reliability', label: 'Reliability' },
  { id: 'safety', label: 'Safety' },
  { id: 'running-costs', label: 'Running Costs' },
  { id: 'acceleration', label: 'Acceleration' },
  { id: 'sitting-high', label: 'Sitting high' },
  { id: 'versatility', label: 'Versatility' },
  { id: 'boot-space', label: 'Boot space' },
  { id: 'space', label: 'Space' },
  { id: 'power', label: 'Power' },
]

export const ABSTRACT_OPTIONS = [
  { id: 'towing', alt: 'Towing' },
  { id: 'speed', alt: 'Speed' },
  { id: 'technology', alt: 'Technology' },
  { id: 'storage', alt: 'Storage' },
  { id: 'off-road', alt: 'Off road' },
  { id: 'electric-car', alt: 'Electric car' },
  { id: 'safety', alt: 'Safety' },
  { id: 'interior', alt: 'Interior' },

  { id: 'music', alt: 'Music' },
  { id: 'comfort', alt: 'Comfort' },
  { id: 'environment', alt: 'Environment' },
  { id: 'excitement', alt: 'Excitement' },
  { id: 'fun', alt: 'Fun' },
  { id: 'luxury', alt: 'Luxury' },
  { id: 'outdoors', alt: 'Outdoors' },
  { id: 'family', alt: 'Family' },
]
